import CommonUtils from '@/resources/utils/common-utils'
import API from '@/config/api'

const cpsApi = {
    state: {},

    mutations: {
        checkCPSAlias(state, data) {
            data.url = API.cps.checkCPSAlias
            CommonUtils.PostRequest(data)
        },
        checkAPIAlias(state, data) {
            data.url = API.cps.checkAPIAlias
            CommonUtils.PostRequest(data)
        },
        getCPSList(state, data) {
            data.url = API.cps.getCPSList
            CommonUtils.GetRequest(data)
        },
        getUploadInfo(state, data) {
            data.url = API.cps.getUploadInfo
            CommonUtils.GetRequest(data)
        },
        uploadMateral(state, data) {
            data.url = API.cps.uploadMateral
            CommonUtils.PostRequest(data)
        },
        changeStatus(state, data) {
            data.url = API.cps.changeStatus
            CommonUtils.GetRequest(data)
        },
        addCPS(state, data) {
            data.url = API.cps.add
            CommonUtils.PostRequest(data)
        },
        editCPS(state, data) {
            data.url = API.cps.edit
            CommonUtils.PostRequest(data)
        },
        getCPSDetails(state, data) {
            data.url = API.cps.getCPSDetail
            CommonUtils.GetRequest(data)
        },
        getCPSLinkList(state, data) {
            data.url = API.cps.getCPSLinkList
            CommonUtils.GetRequest(data)
        },
        getProductCoreList(state, data) {
            data.url = API.cps.getProductCoreList
            CommonUtils.GetRequest(data)
        },
        addProductCore(state, data) {
            data.url = API.cps.addProductCore
            CommonUtils.PostRequest(data)
        },
        getProductDetail(state, data) {
            data.url = API.cps.getProductDetail
            CommonUtils.GetRequest(data)
        },
        getApiProductCoreRateTypeList(state, data) {
            data.url = API.cps.getApiProductCoreRateTypeList
            CommonUtils.GetRequest(data)
        },
        updateProduct(state, data) {
            data.url = API.cps.updateProduct
            CommonUtils.PostRequest(data)
        },
        entryCpsCode(state, data) {
            data.url = API.cps.entryCpsCode
            CommonUtils.PostRequest(data)
        },
        getPlanList(state, data) {
            data.url = API.cps.getPlanList
            CommonUtils.GetRequest(data)
        },
        getCorePlanList(state, data) {
            data.url = API.cps.getCorePlanList
            CommonUtils.GetRequest(data)
        },
        getCpsInfo(state, data) {
            data.url = API.cps.getCpsInfo
            CommonUtils.GetRequest(data)
        },
        getProgramLists(state, data) {
            data.url = API.cps.getProgramLists
            CommonUtils.GetRequest(data)
        },
        getCoreProgramLists(state, data) {
            data.url = API.cps.getCoreProgramLists
            CommonUtils.GetRequest(data)
        },
        getIrTypeLists(state, data) {
            data.url = API.cps.getIrTypeLists
            CommonUtils.GetRequest(data)
        },
        addCoefficientPlan(state, data) {
            let typeUrl =
                data.type === 'copy'
                    ? API.cps.copyCoefficientPlan
                    : API.cps.addCoefficientPlan
            data.url = `${typeUrl}?cps_product_id=${data.data.cps_product_id}`
            CommonUtils.PostRequest(data)
        },
        addCoreCoefficientPlan(state, data) {
            let typeUrl =
                data.type === 'copy'
                    ? API.cps.copyCoreCoefficientPlan
                    : API.cps.addCoreCoefficientPlan
            data.url = `${typeUrl}?product_id=${data.data.product_id}`
            CommonUtils.PostRequest(data)
        },
        getPlanInfo(state, data) {
            data.url = API.cps.getPlanInfo
            CommonUtils.GetRequest(data)
        },
        getCorePlanInfo(state, data) {
            data.url = API.cps.getCorePlanInfo
            CommonUtils.GetRequest(data)
        },
        deletePlan(state, data) {
            data.url = API.cps.deletePlan
            CommonUtils.GetRequest(data)
        },
        deleteCorePlan(state, data) {
            data.url = API.cps.deleteCorePlan
            CommonUtils.GetRequest(data)
        },
        updatePlanInfo(state, data) {
            data.url = `${API.cps.updatePlanInfo}?id=${data.data.id}&cps_product_id=${data.data.cps_product_id}`
            CommonUtils.PostRequest(data)
        },
        updateCorePlanInfo(state, data) {
            data.url = `${API.cps.updateCorePlanInfo}?id=${data.data.id}&product_id=${data.data.product_id}`
            CommonUtils.PostRequest(data)
        },
        getCoreKeyWordLists(state, data) {
            data.url = API.cps.getCoreKeyWordLists
            CommonUtils.GetRequest(data)
        },
        getCoreProdInfo(state, data) {
            data.url = API.cps.getCoreProdInfo
            CommonUtils.GetRequest(data)
        },
        uploadExcel(state, data) {
            data.url = API.cps.cpsBatchUploadExcel
            data.headers = {
                'Content-Type':
                    'multipart/form-data;boundary = ' + new Date().getTime()
            }
            data.isUpload = true
            CommonUtils.PostRequest(data)
        },
        uploadInsuranceExcel(state, data) {
            data.url = API.cps.cpsBatchUploadInsuranceTypeExcel
            data.headers = {
                'Content-Type':
                    'multipart/form-data;boundary = ' + new Date().getTime()
            }
            data.isUpload = true
            CommonUtils.PostRequest(data)
        },
        uploadParamExcel(state, data) {
            data.url = API.cps.cpsBatchUploadParamExcel
            data.headers = {
                'Content-Type':
                    'multipart/form-data;boundary = ' + new Date().getTime()
            }
            data.isUpload = true
            CommonUtils.PostRequest(data)
        },
        cpsBatchUploadByQX(state, data) {
            data.url = API.cps.cpsBatchUploadByQX
            CommonUtils.PostRequest(data)
        },
        cpsBatchUploadByZA(state, data) {
            data.url = API.cps.cpsBatchUploadByZA
            CommonUtils.PostRequest(data)
        },
        getKeyWordLists(state, data) {
            data.url = API.cps.getKeyWordLists
            CommonUtils.GetRequest(data)
        },
        getApiProductBaseInfo(state, data) {
            data.url = API.cps.getApiProductBaseInfo
            CommonUtils.GetRequest(data)
        },
        getApiProductParamsInfo(state, data) {
            data.url = API.cps.getApiProductParamsInfo
            CommonUtils.GetRequest(data)
        },
        getApiProductInsurance(state, data) {
            data.url = API.cps.getApiProductInsurance
            CommonUtils.GetRequest(data)
        },
        editApiProductBaseInfo(state, data) {
            data.url = API.cps.editApiProductBaseInfo
            CommonUtils.PostRequest(data, true)
        },
        editApiProductParamsInfo(state, data) {
            data.url = API.cps.editApiProductParamsInfo
            CommonUtils.PostRequest(data)
        },
        editApiProductInsuranceInfo(state, data) {
            data.url = API.cps.editApiProductInsuranceInfo
            CommonUtils.PostRequest(data)
        },
        underwriteRulesUpload(state, data) {
            data.url = API.cps.underwriteRulesUpload
            CommonUtils.PostRequest(data)
        },
        customeriteRulesUpload(state, data) {
            data.url = API.cps.customeriteRulesUpload
            CommonUtils.PostRequest(data)
        },
        claimSettlementUpload(state, data) {
            data.url = API.cps.claimSettlementUpload
            CommonUtils.PostRequest(data)
        },
        underwriteRulesRecode(state, data) {
            data.url = API.cps.underwriteRulesRecode
            CommonUtils.GetRequest(data)
        },
        customerLogList(state, data) {
            data.url = API.cps.customerLogList
            CommonUtils.GetRequest(data)
        },
        claimSettlementRulesRecode(state, data) {
            data.url = API.cps.claimSettlementRulesRecode
            CommonUtils.GetRequest(data)
        },
        underwriteRulesList(state, data) {
            data.url = API.cps.underwriteRulesList
            CommonUtils.GetRequest(data)
        },
        deleteUnderwriteRule(state, data) {
            data.url = API.cps.deleteUnderwriteRule
            CommonUtils.GetRequest(data)
        },
        insuranceRulesList(state, data) {
            data.url = API.cps.insuranceRulesList
            CommonUtils.GetRequest(data)
        },
        customerServiceList(state, data) {
            data.url = API.cps.customerServiceList
            CommonUtils.GetRequest(data)
        },
        // 售后指引
        salesGuidelinesList(state, data) {
            data.url = API.cps.salesGuidelinesList
            CommonUtils.GetRequest(data)
        },
        // cps和api产品列表
        getAllProductList(state, data) {
            data.url = API.common.getAllProductList
            CommonUtils.GetRequest(data)
        },
        salesGuidelinesLogList(state, data) {
            data.url = API.cps.salesGuidelinesLogList
            CommonUtils.GetRequest(data)
        },
        salesGuidelinesUpload(state, data) {
            data.url = API.cps.salesGuidelinesUpload
            CommonUtils.PostRequest(data)
        },
        deleteSalesGuidelines(state, data) {
            data.url = API.cps.deleteSalesGuidelines
            CommonUtils.PostRequest(data)
        },
        showSalesGuidelinesColumns(state, data) {
            data.url = API.cps.showSalesGuidelinesColumns
            CommonUtils.GetRequest(data)
        },
        setSalesGuidelinesColumns(state, data) {
            data.url = API.cps.setSalesGuidelinesColumns
            CommonUtils.PostRequest(data)
        },
        productConnectManual(state, data) {
            data.url = API.common.productConnectManual
            CommonUtils.PostRequest(data)
        },
        claimSettlementList(state, data) {
            data.url = API.cps.claimSettlementList
            CommonUtils.GetRequest(data)
        },
        deleteInsuranceRule(state, data) {
            data.url = API.cps.deleteInsuranceRule
            CommonUtils.GetRequest(data)
        },
        deleteCustomerService(state, data) {
            data.url = API.cps.deleteCustomerService
            CommonUtils.PostRequest(data)
        },
        deleteClaimSettlement(state, data) {
            data.url = API.cps.deleteClaimSettlement
            CommonUtils.PostRequest(data)
        },
        uploadFile(state, data) {
            data.url = API.cps.uploadFile
            CommonUtils.GetRequest(data)
        },
        getHealthNoticeDetail(state, data) {
            data.url = API.cps.getHealthNoticeDetail
            CommonUtils.GetRequest(data)
        },
        getUnderwritingDetail(state, data) {
            data.url = API.cps.getUnderwritingDetail
            CommonUtils.GetRequest(data)
        },
        getUnderwritingUploadRecord(state, data) {
            data.url = API.cps.getUnderwritingUploadRecord
            CommonUtils.GetRequest(data)
        },
        getHealthNoticeUploadRecord(state, data) {
            data.url = API.cps.getHealthNoticeUploadRecord
            CommonUtils.GetRequest(data)
        },
        getUnderwritingProductList(state, data) {
            data.url = API.cps.getUnderwritingProductList
            CommonUtils.GetRequest(data)
        },
        getHealthNoticeProductList(state, data) {
            data.url = API.cps.getHealthNoticeProductList
            CommonUtils.GetRequest(data)
        },
        removeHealthNoticeProduct(state, data) {
            data.url = API.cps.removeHealthNoticeProduct
            CommonUtils.PostRequest(data)
        },
        removeUnderwritingProduct(state, data) {
            data.url = API.cps.removeUnderwritingProduct
            CommonUtils.PostRequest(data)
        },
        getUnderwriteRuleList(state, data) {
            data.url = API.cps.getUnderwriteRuleList
            CommonUtils.GetRequest(data)
        },
        getUnderwriteRuleDetail(state, data) {
            data.url = API.cps.getUnderwriteRuleDetail
            CommonUtils.GetRequest(data)
        },
        getQuestionTagList(state, data) {
            data.url = API.cps.getQuestionTagList
            CommonUtils.GetRequest(data)
        },
        addQuestionTag(state, data) {
            data.url = API.cps.addQuestionTag
            CommonUtils.PostRequest(data)
        },
        removeQuestionTag(state, data) {
            data.url = API.cps.removeQuestionTag
            CommonUtils.GetRequest(data)
        },
        getQuestionContentList(state, data) {
            data.url = API.cps.getQuestionContentList
            CommonUtils.GetRequest(data)
        },
        removeQuestionContent(state, data) {
            data.url = API.cps.removeQuestionContent
            CommonUtils.GetRequest(data)
        },
        editQuestionContent(state, data) {
            data.url = API.cps.editQuestionContent
            CommonUtils.PostRequest(data)
        },
        addQuestionContent(state, data) {
            data.url = API.cps.addQuestionContent
            CommonUtils.PostRequest(data)
        },
        getQuestionContentTagList(state, data) {
            data.url = API.cps.getQuestionContentTagList
            CommonUtils.GetRequest(data)
        },
        getQuestionDetail(state, data) {
            data.url = API.cps.getQuestionDetail
            CommonUtils.GetRequest(data)
        },
        toggleRecommendStatus(state, data) {
            data.url = API.cps.toggleRecommendStatus
            CommonUtils.GetRequest(data)
        },
        getQuestionSearchProblemList(state, data) {
            data.url = API.cps.getQuestionSearchProblemList
            CommonUtils.GetRequest(data)
        },
        copyCountIncrement(state, data) {
            data.url = API.cps.copyCountIncrement
            CommonUtils.GetRequest(data)
        },
        toggleCollection(state, data) {
            data.url = API.cps.toggleCollection
            CommonUtils.GetRequest(data)
        },
        setBaseAttribute(state, data) {
            data.url = API.cps.setBaseAttribute
            CommonUtils.PostRequest(data)
        },
        getInsuranceCategoryMap(state, data) {
            data.url = API.cps.getInsuranceCategoryMap
            CommonUtils.GetRequest(data)
        },
        getBaseAttributeDetail(state, data) {
            data.url = API.cps.getBaseAttributeDetail
            CommonUtils.GetRequest(data)
        },
        getProductAnnualDeliveryOptions(state, data) {
            data.url = API.cps.getProductAnnualDeliveryOptions
            CommonUtils.GetRequest(data)
        },
        setProductCoefficient(state, data) {
            data.url = API.cps.setProductCoefficient
            CommonUtils.PostRequest(data)
        },
        updateProductCoefficient(state, data) {
            data.url = API.cps.updateProductCoefficient
            CommonUtils.PostRequest(data)
        },
        getProductCoefficientList(state, data) {
            data.url = API.cps.getProductCoefficientList
            CommonUtils.PostRequest(data)
        },
        getProductCoefficientDetail(state, data) {
            data.url = API.cps.getProductCoefficientDetail
            CommonUtils.GetRequest(data)
        },
        delProductCoefficientItem(state, data) {
            data.url = API.cps.delProductCoefficientItem
            CommonUtils.GetRequest(data)
        },
        getSingleChannelList(state, data) {
            data.url = API.cps.getSingleChannelList
            CommonUtils.GetRequest(data)
        },
        editCPSPromoteInfo(state, data) {
            data.url = API.cps.editCPSPromoteInfo
            CommonUtils.PostRequest(data)
        },
        editAPIPromoteInfo(state, data) {
            data.url = API.cps.editAPIPromoteInfo
            CommonUtils.PostRequest(data)
        },
        getProductEvaluationFieldsTpl(state, data) {
            data.url = API.cps.getProductEvaluationFieldsTpl
            CommonUtils.GetRequest(data)
        },
        getProductEvaluationProposalProductList(state, data) {
            data.url = API.cps.getProductEvaluationProposalProductList
            CommonUtils.GetRequest(data)
        },
        getProductEvaluationProductList(state, data) {
            data.url = API.cps.getProductEvaluationProductList
            CommonUtils.GetRequest(data)
        },
        getProductEvaluationConstantOptions(state, data) {
            data.url = API.cps.getProductEvaluationConstantOptions
            CommonUtils.GetRequest(data)
        },
        addProductEvaluation(state, data) {
            data.url = API.cps.addProductEvaluation
            CommonUtils.PostRequest(data)
        },
        getProposalProductDetail(state, data) {
            data.url = API.cps.getProposalProductDetail
            CommonUtils.GetRequest(data)
        },
        setProductStatus(state, data) {
            data.url = API.cps.setProductStatus
            CommonUtils.PostRequest(data)
        },
        getProdctEvaluationDetail(state, data) {
            data.url = API.cps.getProdctEvaluationDetail
            CommonUtils.GetRequest(data)
        },
        updateProductEvaluation(state, data) {
            data.url = API.cps.updateProductEvaluation
            CommonUtils.PostRequest(data)
        },
        getProductEvaluationCopy(state, data) {
            data.url = API.cps.getProductEvaluationCopy
            CommonUtils.GetRequest(data)
        },
        getProductRate(state, data) {
            data.url = API.cps.getProductRate
            CommonUtils.GetRequest(data)
        },
        // ---------继续率产品关联-------------
        // 继续率计算关联(产品分组)
        getProductGroupList(state, data) {
            data.url = API.cps.getProductGroupList
            CommonUtils.GetRequest(data)
        },
        // 供应商下拉数据
        getSuplierList(state, data) {
            data.url = API.cps.getSuplierList
            CommonUtils.GetRequest(data)
        },
        // 险种数据
        getInsuranceData(state, data) {
            data.url = API.cps.getInsuranceData
            CommonUtils.GetRequest(data)
        },
        // 产品列表
        getApiProductData(state, data) {
            data.url = API.cps.getApiProductData
            CommonUtils.GetRequest(data)
        },
        // 创建产品分组
        createProductGroup(state, data) {
            data.url = API.cps.createProductGroup
            CommonUtils.PostRequest(data)
        },
        // 删除产品分组
        deleteProductGroup(state, data) {
            data.url = API.cps.deleteProductGroup
            CommonUtils.GetRequest(data)
        },
        // 产品分组详情
        getProductGroupDetail(state, data) {
            data.url = API.cps.getProductGroupDetail
            CommonUtils.GetRequest(data)
        },
        // 创建单品产品列表
        getApiCpsProducts(state, data) {
            data.url = API.cps.getApiCpsProducts
            CommonUtils.GetRequest(data)
        },
        // 批量创建产品分组
        batchProductGroup(state, data) {
            data.url = API.cps.batchProductGroup
            CommonUtils.PostRequest(data)
        },
        // -----------手续费页---------------
        // 编辑新增方案提交
        createCommission(state, data) {
            data.url = API.cps.createCommission
            CommonUtils.PostRequest(data)
        },
        // 方案列表
        getCommissionList(state, data) {
            data.url = API.cps.getCommissionList
            CommonUtils.GetRequest(data)
        },
        // 方案详情
        getCommissionDetail(state, data) {
            data.url = API.cps.getCommissionDetail
            CommonUtils.GetRequest(data)
        },
        // 属性列表
        getProductAttr(state, data) {
            data.url = API.cps.getProductAttr
            CommonUtils.GetRequest(data)
        },
        // 删除方案列表
        deleteScheme(state, data) {
            data.url = API.cps.deleteScheme
            CommonUtils.GetRequest(data)
        },
        // 首期手续分清单
        getPolicyList(state, data) {
            data.url = API.cps.getPolicyList
            CommonUtils.GetRequest(data)
        },
        // 上传清单
        exportFirstYearCommissionList(state, data) {
            data.url = API.cps.exportFirstYearCommissionList
            CommonUtils.GetRequest(data)
        },
        // 产品资料 - 列表
        getProductDocCategoryList(state, data) {
            data.url = API.cps.getProductDocCategoryList
            CommonUtils.GetRequest(data)
        },
        // 产品资料 - 保存分类
        saveProductDocCategory(state, data) {
            data.url = API.cps.saveProductDocCategory
            CommonUtils.PostRequest(data)
        },
        // 预核保-获取预核保订单
        getPreOrderList(state, data) {
            data.url = API.cps.getPreOrderList
            CommonUtils.GetRequest(data)
        },
        // 预核保-获取预核保分享链接
        getPreSelectOptions(state, data) {
            data.url = API.cps.getPreSelectOptions
            CommonUtils.GetRequest(data)
        },
        getPreShareLink(state, data) {
            data.url = API.cps.getPreShareLink
            CommonUtils.GetRequest(data)
        },

    }
}

export default cpsApi



// WEBPACK FOOTER //
// ./src/store/modules/cps.js